var _style, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 24",
    style: {
      enableBackground: "new 0 0 28 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCC;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14,23 2,11.6 2.4,3.3 7.7,1.2 12.9,2.9 14.1,3.6 18.5,1.2 22.8,1.8 25.5,4.2 26.2,9 25,12.5 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,2.7c-0.5-0.5-1-1-1.6-1.4C11.2,0.5,9.6,0,8,0C3.9,0,0.7,3.2,0.7,7.2c0,1.4,0.3,2.8,0.9,4.1 c1.8,4,6,7.4,9.5,10.3c1,0.8,2,1.6,2.9,2.4c0.9-0.8,1.8-1.6,2.9-2.4c3.6-2.9,7.7-6.3,9.5-10.3c0.6-1.3,0.9-2.7,0.9-4.1 c0-4-3.2-7.2-7.3-7.2c-1.6,0-3.2,0.5-4.4,1.3C15,1.7,14.5,2.1,14,2.7z M14,20.5c0.4-0.4,0.9-0.7,1.3-1.1c0.4-0.3,0.7-0.6,1.1-0.9 c1.5-1.2,2.9-2.4,4.2-3.7c1.6-1.6,2.7-3.1,3.4-4.6c0.4-1,0.7-2,0.7-3c0-2.5-2-4.5-4.7-4.5c-1.6,0-3.1,0.7-4,1.7l-2,2.3l-2-2.3 c-0.9-1.1-2.4-1.7-4-1.7c-2.7,0-4.7,2-4.7,4.5c0,1,0.2,2,0.7,3c0.7,1.5,1.8,3,3.4,4.6c1.3,1.3,2.7,2.5,4.2,3.7 c0.4,0.3,0.7,0.6,1.1,0.9C13.1,19.8,13.6,20.1,14,20.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b43da3c8.svg";
export { ForwardRef as ReactComponent };